// extracted by mini-css-extract-plugin
export default {"calendarWeek":"calendar-week_calendarWeek__4a-Vo"};